(function () {
  'use strict';

  let scriptLoaded = false;

  function loadJSscripts() {
    if (scriptLoaded) return;

    scriptLoaded = true;
    if (window.lazyObserver) {
      window.lazyObserver.disconnect();
    }

    // Load lazy iframes
    document.querySelectorAll('iframe.lazy').forEach((iframe) => {
      const dataSrc = iframe.dataset.src;
      if (dataSrc != null) {
        iframe.src = dataSrc;
      }
    });

    // Load deferred scripts (data-src -> src)
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      const script = scripts[i];

      if (script.getAttribute('data-src') !== null) {
        script.setAttribute('src', script.getAttribute('data-src'));
        delete script.dataset.src;
        script.setAttribute('data-lazyload', 'loaded');
      }

      if (script.getAttribute('type') === 'text/lazyload') {
        const newScript = document.createElement('script');

        for (let j = 0; j < script.attributes.length; j++) {
          const attr = script.attributes[j];
          newScript.setAttribute(attr.name, attr.value);
        }

        newScript.type = 'text/javascript';
        newScript.innerHTML = script.innerHTML;
        script.parentNode.replaceChild(newScript, script);
      }
    }

    // Load deferred stylesheets (data-href -> href)
    const links = document.getElementsByTagName('link');
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      if (link.getAttribute('data-href') !== null) {
        link.setAttribute('href', link.getAttribute('data-href'));
        link.setAttribute('data-lazyload', 'loaded');
        delete link.dataset.href;
      }
    }

    document.dispatchEvent(new CustomEvent('asyncLazyLoad'));
  }

  // Set up event listeners
  const activityEvents = [
    'mousedown',
    'mousemove',
    'keydown',
    'scroll',
    'touchstart',
    'click',
    'keypress',
    'touchmove',
  ];

  activityEvents.forEach(function (eventName) {
    window.addEventListener(eventName, loadJSscripts, { passive: true, once: true });
  });

  if (window.addEventListener) {
    window.addEventListener(
      'load',
      function () {
        setTimeout(function () {
          if (!scriptLoaded) {
            loadJSscripts();
          }
        }, 3000);
      },
      false
    );
  } else if (window.attachEvent) {
    window.attachEvent('onload', function () {
      setTimeout(function () {
        if (!scriptLoaded) {
          loadJSscripts();
        }
      }, 3000);
    });
  }
})();
